var map = {
	"./apple-laurel-da-DK.svg": 85034,
	"./apple-laurel-de-DE.svg": 22008,
	"./apple-laurel-en-GB.svg": 39402,
	"./apple-laurel-en-US.svg": 31153,
	"./apple-laurel-es-ES.svg": 10098,
	"./apple-laurel-es-MX.svg": 37649,
	"./apple-laurel-fr-FR.svg": 5874,
	"./apple-laurel-it-IT.svg": 91280,
	"./apple-laurel-nb-NO.svg": 2975,
	"./apple-laurel-nl-NL.svg": 19694,
	"./apple-laurel-pl-PL.svg": 7910,
	"./apple-laurel-pt-BR.svg": 40202,
	"./apple-laurel-pt-PT.svg": 11014,
	"./apple-laurel-sv-SE.svg": 39491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;